/**
 * charactr.ts - Charactr (Memory & Environment) preferences module
 * 
 * CHANGE HISTORY:
 * - 251031_1600 [pending] danielbeer: Initial creation
 */

export const charactrModule = {
  id: 'infra-charactr',
  name: 'Memory & Environment',
  icon: '🧠',
  category: 'modules',
  order: 22,
  
  packageInfo: {
    name: '@danielbeer/charactr',
    version: '1.0.0',
    displayVersion: '1.0.0',
    description: 'Intelligent memory routing system that shapes the character of your development environment',
    status: 'production',
    implementationProgress: 100,
    dependencies: {
      'firebase': '^11.0.0'
    },
    peerDependencies: {
      '@opcentral/loggr': '*',
      '@opcentral/gittr': '*',
      '@opcentral/synkr': '*'
    },
    keywords: ['memory', 'environment', 'sessions', 'context', 'ai'],
    author: 'Daniel Beer',
    license: 'MIT',
    repository: 'https://github.com/danielbeer/charactr',
    location: '~/code/Charactr'
  },
  
  settings: {
    enableMemorySystem: {
      type: 'boolean',
      label: 'Enable Memory System',
      description: 'Use Charactr for session memory',
      defaultValue: true
    },
    
    memoryRetention: {
      type: 'number',
      label: 'Memory Retention (days)',
      description: 'How long to keep session memories',
      defaultValue: 30,
      min: 7,
      max: 365,
      visible: (settings) => settings['infra-charactr.enableMemorySystem']
    },
    
    autoCommitSessions: {
      type: 'boolean',
      label: 'Auto-Commit Sessions',
      description: 'Automatically commit session data to git',
      defaultValue: true,
      visible: (settings) => settings['infra-charactr.enableMemorySystem']
    },
    
    sessionSummaries: {
      type: 'boolean',
      label: 'Generate Session Summaries',
      description: 'Create summaries at end of sessions',
      defaultValue: true,
      visible: (settings) => settings['infra-charactr.enableMemorySystem']
    }
  }
};

export default charactrModule;
